import { createSlice } from '@reduxjs/toolkit';

/**
 * The station printers, shared.
 *
 * In the store rather than in one screen's state because two places need
 * them: Administration, to manage them, and the order pad, to work out where
 * a kitchen ticket goes when an order is edited or reprinted (the server only
 * builds that plan for a NEW order).
 *
 * Wiped on logout by the reset in store.js — one shop's printers must never
 * be reachable from the next.
 */
const initialState = {
  printers: [],
  isPrintersDataFetched: false,
};

const printerSlice = createSlice({
  name: 'printers',
  initialState,
  reducers: {
    setPrinters: (state, action) => {
      state.printers = action.payload || [];
    },

    setPrintersDataFetched: (state, action) => {
      state.isPrintersDataFetched = action.payload;
    },

    addPrinter: (state, action) => {
      if (action.payload) state.printers.push(action.payload);
    },

    updatePrinter: (state, action) => {
      const { _id, updated } = action.payload;
      const index = state.printers.findIndex((printer) => printer._id === _id);
      if (index !== -1) {
        state.printers[index] = { ...state.printers[index], ...updated };
      }
    },

    removePrinter: (state, action) => {
      state.printers = state.printers.filter((printer) => printer._id !== action.payload);
    },
  },
});

export const {
  setPrinters,
  setPrintersDataFetched,
  addPrinter,
  updatePrinter,
  removePrinter,
} = printerSlice.actions;

export default printerSlice.reducer;
